import service from './service';
import { UrlBuilder } from './url-builder';

export const counponCreation = async (payload) => {
  const builder = new UrlBuilder(`/coupon/create`);
  try {
    const response = await service.post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const counponDeletion = async (couponId) => {
  const builder = new UrlBuilder(`/coupon/${couponId}`);

  const response = await service.remove(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const getCouponList = async () => {
  const builder = new UrlBuilder(`/coupon/list-coupons`);

  const response = await service.get(builder.toString());

  if (response.status === 200) {
    return response.data;
  }

  return 0;
};
